/**
 * Created by asiulik on 23.11.2017.
 */

define(['jquery'], function($){

    function FormTooltip(){}

    FormTooltip.prototype.init = function(){

        var $tooltipItems = $('[data-tooltip--trigger]');
        if(!$tooltipItems.length) return;

        [].forEach.call($tooltipItems, function(tooltipTrigger) {

            var $tooltipTrigger = $(tooltipTrigger);
            var $tooltipParent = $tooltipTrigger.parent();

            var $tooltipContainer = $tooltipParent.find('.input-field__tooltip');
            var $tooltipClose = $tooltipContainer.find('.tooltip__close');

            $tooltipTrigger.on({
                click: function(){
                    // console.log('tooltip trigger clicked');
                    $tooltipContainer.addClass('input-field__tooltip--active');
                }
            });

            $tooltipClose.on({
                click: function(){
                    $tooltipContainer.removeClass('input-field__tooltip--active');
                }
            });

        });

    };

    return FormTooltip;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/forms/form__tooltip.js